import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { Suspense, lazy } from "react";

const SubscriptionPage = lazy(() => import("./SubscriptionsPage"));

const SubscriptionPageLazy = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <SubscriptionPage />
    </Suspense>
  );
};

export default SubscriptionPageLazy;
